export { default } from './RatingIndex';
